import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    '@global': {
      a: {
        textDecoration: 'none',
        color: theme.palette.primary.main,
      },
      '.MuiListItemText-primary': {
        fontSize: '0.97rem',
      },
      html: {
        '-ms-text-size-adjust': '100%',
        '-webkit-text-size-adjust': '100%',
        '-webkit-tap-highlight-color': 'transparent',
      },
      '.MuiSvgIcon-root': {
        fontSize: '1.15rem',
      },
      '.MuiListItemIcon-root': {
        minWidth: 48,
      },
      '.MuiTypography-subtitle2': {
        fontSize: '0.8rem',
      },
      '.MuiDivider-root ': {
        backgroundColor: ' rgb(0 0 0 / 7%)',
      },
      '::-webkit-scrollbar': {
        width: 7,
        height: 6,
        backgroundColor: theme.palette.background.paper,
      },
      '::-webkit-scrollbar-track': {
        borderRadius: 3,
      },
      '::-webkit-scrollbar-thumb': {
        borderRadius: 4,
        backgroundColor: theme.palette.primary.main,
      },
      '.MuiButton-root': {
        textTransform: 'unset',
      },
    },
  }),
);

const GlobalStyles = () => {
  useStyles();
  return null;
};

export default GlobalStyles;
